import { createAction } from '@reduxjs/toolkit';

import type {
  ConfigChange,
  CanvasOptionChangePayload,
  PriceToolSizePayload,
  CustomSizePricePayload,
  CustomSizeOptionPayload,
  CreateCanvasPayload,
  MovementPayload,
  NextSizePayload,
} from './canvases.types';
import type { Dimension, Pair } from 'types/common_types';

const changeActiveCanvasConfig = {
  catalog: createAction<number>('canvases/changeActiveCanvasConfig/catalog'),
  subcatalog: createAction<number>('canvases/changeActiveCanvasConfig/subcatalog'),
  product: createAction<number>('canvases/changeActiveCanvasConfig/product'),
  options: createAction<CanvasOptionChangePayload>('canvases/changeActiveCanvasConfig/options'),
  multi: createAction<ConfigChange>('canvases/changeActiveCanvasConfig/multi'),
  size: createAction<Partial<Dimension>>('canvases/changeActiveCanvasConfig/size'),
  priceToolSize: createAction<PriceToolSizePayload>(
    'canvases/changeActiveCanvasConfig/priceToolSize'
  ),
};

const calculateCustomPrice = {
  pending: createAction<CustomSizePricePayload>('canvases/calculateCustomPrice/pending'),
  fulfilled: createAction<string>('canvases/calculateCustomPrice/fulfilled'),
  rejected: createAction<string | undefined>('canvases/calculateCustomPrice/rejected'),
};

const calculateCustomOptionPrices = {
  pending: createAction<CustomSizeOptionPayload>('canvases/calculateCustomOptionPrices/pending'),
  fulfilled: createAction<Pair<string, number>[]>('canvases/calculateCustomOptionPrices/fulfilled'),
  rejected: createAction('canvases/calculateCustomOptionPrices/rejected'),
};

const createCanvas = createAction<CreateCanvasPayload>('canvases/createCanvas');

const moveArrangement = createAction<MovementPayload>('canvases/moveArrangement');
const moveCanvas = createAction<MovementPayload & { id: string; next?: NextSizePayload }>(
  'canvases/moveCanvas'
);

export default {
  changeActiveCanvasConfig,
  calculateCustomPrice,
  calculateCustomOptionPrices,
  createCanvas,
  moveArrangement,
  moveCanvas,
};
